import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import translations from "../../translations";
import CountdownTimer from "../countdown-timer/countdown-timer.components";
import SocialLinks from "../drop-social-links/drop-social-links.component";
import "./drop-section.components.css";

const DropSection = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fullName, setFullName] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [language, setLanguage] = useState("fa");
  const [isOpenForm, setIsOpenForm] = useState(false);

  const navigate = useNavigate();

  // اگر قبلاً رمز درست در localStorage ذخیره شده باشد، کاربر را مستقیم می‌فرستیم به /shop-drop-page
  useEffect(() => {
    const storedPassword = localStorage.getItem("dropAccessPassword");
    if (storedPassword === "1405") {
      navigate("/shop-drop-page", { replace: true });
    }
  }, [navigate]);

  // تابع برای نمایش/عدم‌نمایش فرم لیست‌انتظار
  const handleCheckboxChange = () => {
    setIsOpenForm((prev) => !prev);
  };

  // تابع کمکی ترجمه (در صورت نیاز)
  const t = (key) => {
    const langData = translations[language] || translations["fa"];
    return langData[key] || key;
  };

  // فرم مربوط به رمز
  const handleMainFormSubmit = (e) => {
    e.preventDefault();
    const password = document.getElementById("password-input").value;
    if (password === "1405") {
      // رمز صحیح؛ در localStorage ذخیره شود
      localStorage.setItem("dropAccessPassword", "1405");
      toast.success("ورود موفقیت‌آمیز!");
      // هدایت به صفحهٔ محافظت‌شده
      navigate("/shop-drop-page");
    } else {
      alert("رمز اشتباه است");
    }
  };

  // فرم مربوط به لیست انتظار
  const handleRestOfFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = new FormData();
    data.append("email", email);
    data.append("phone", phone);
    data.append("full_name", fullName);
    data.append("campaign_id", "3");

    try {
      const response = await axios.post(
        "https://mediumaquamarine-rat-574365.hostingersite.com/api/request-waitlist",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.is_status) {
        toast.success("✅ درخواست شما با موفقیت ثبت شد.", {
          style: {
            direction: "rtl",
            textAlign: "right",
            fontFamily: "iranyekan",
            fontWeight: 500,
            fontSize: "14px",
          },
        });
        setIsSubmitted(true);
      } else {
        const errorMessage =
          response.data.message ||
          "❌ خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
        toast.error(errorMessage, {
          style: {
            direction: "rtl",
            textAlign: "right",
            fontFamily: "iranyekan",
            fontWeight: 500,
            fontSize: "14px",
          },
        });
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message, {
          style: {
            direction: "rtl",
            textAlign: "right",
            fontFamily: "iranyekan",
            fontWeight: 500,
            fontSize: "14px",
          },
        });
      } else {
        toast.error("❌ خطا در ارسال درخواست. لطفاً دوباره تلاش کنید.", {
          style: {
            direction: "rtl",
            textAlign: "right",
            fontFamily: "iranyekan",
            fontWeight: 500,
            fontSize: "14px",
          },
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="drop-section">
      <div className="drop-container-home">
        <div className="scrol-container">
          <div
            className={`section-home section-large ${
              isOpenForm ? "open-form" : ""
            }`}
          >
            {/* فرم اول فقط مخصوص رمز */}
            <form className="form-home" onSubmit={handleMainFormSubmit}>
              <div className="form-group">
                <input
                  name="password"
                  id="password-input"
                  type="password"
                  className="form-input form-password-input"
                  required
                />
                <label className="form-password-label" htmlFor="password-input">
                  رمز
                </label>
                <button type="submit" className="submit-button">
                  ورود
                </button>
              </div>
            </form>

            <div className="rest-of-the-form-main-wrapper">
              {/* چک‌باکس برای باز/بسته کردن فرم دوم */}
              <input
                type="checkbox"
                className="rest-of-form-check-input"
                id="rest-of-form-check-input"
                onChange={handleCheckboxChange}
                hidden
              />
              <label
                htmlFor="rest-of-form-check-input"
                className="rest-of-form-check-label"
              >
                برای دریافت رمز وارد لیست انتظار شید
              </label>

              {/* فرم دوم مربوط به لیست انتظار (در صورت فعال بودن چک‌باکس نمایش داده شود) */}
              {isOpenForm && (
                <form
                  className="rest-of-form-wrapper"
                  onSubmit={handleRestOfFormSubmit}
                >
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-input"
                      required
                      placeholder="نام کامل"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-input"
                      required
                      placeholder="ایمیل"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-input"
                      placeholder="شماره تلفن"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <button
                    className="rest-of-form-submit-button"
                    type="submit"
                    disabled={isLoading || isSubmitted}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner"></span> در حال ارسال...
                      </>
                    ) : isSubmitted ? (
                      "انجام شد"
                    ) : (
                      "ارسال"
                    )}
                  </button>
                </form>
              )}
            </div>
            <div className="form-text-wrapper">
              <p className="form-mini-text">
                کاربران ایرانی می‌توانند ایمیل و شماره تلفن خود را ارائه دهند،
                در حالی که کاربران خارج از ایران فقط از طریق ایمیل قابل تماس
                هستند
              </p>
              <p className="form-mini-text">
                * دسترسی به محصولات فقط با رمز عبور امکان‌پذیر است *
              </p>
            </div>

            <div className="count-down-container">
              <div className="custom-countdown">{/* <CountdownTimer /> */}</div>
            </div>

            <SocialLinks />
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        rtl={true}
        style={{ fontFamily: "iranyekan", fontWeight: 500 }}
      />
    </div>
  );
};

export default DropSection;
